import { ligainicial } from "./rutainicial.js";
import { pagesipdus } from "./rutainicial";

const ligabase = ligainicial + "2026/Lic/C";
const ligasipdus = pagesipdus + "2026/Lic/C";
const ligasipdusInv = pagesipdus + "2026/Inv/";

export const licitacionesVigentes = [
    {
        // CONVOCATORIA NUM# 050
        'numConvocatoria' : 'Convocatoria No. 050/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N171-2026.',
        'vigencia' : '12 al 16 de octubre de 2026.',
        'descripcionProcedimiento' : 'Banquetas con concreto estampado, guarniciones y luminarias de Av. Francisco I. Madero, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }50/N171/N171.rar`,
        'start' : '2026-10-12',
        'end' : '2026-10-16',
        'procedimiento' : 'Licitación Pública',
    },
    {
        // CONVOCATORIA NUM# 049
        'numConvocatoria' : 'Convocatoria No. 049/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N170-2026.',
        'vigencia' : '12 al 23 de octubre de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación de la Escuela de Música del Estado de Hidalgo; de Cobertura Estatal.',
        'urlAnexos' : `${ ligasipdus }49/N170/N170.rar`,
        'start' : '2026-10-12',
        'end' : '2026-10-23',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N169-2026.',
        'vigencia' : '12 al 23 de octubre de 2026.',
        'descripcionProcedimiento' : 'Construcción del nuevo Centro Gerontológico Integral de Huejutla de Reyes (tercera etapa); ubicada en la localidad y Municipio de Huejutla de Reyes, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }49/N169/N169.rar`,
        'start' : '2026-10-12',
        'end' : '2026-10-23',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N168-2026.',
        'vigencia' : '12 al 23 de octubre de 2026.',
        'descripcionProcedimiento' : 'Construcción y Remodelación del Edificio Principal del Instituto Hidalguense de Educación; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }49/N168/N168.rar`,
        'start' : '2026-10-12',
        'end' : '2026-10-23',
        'procedimiento' : 'Licitación Pública',
    },
    {
        // CONVOCATORIA NUM# 048
        'numConvocatoria' : 'Convocatoria No. 048/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N167-2026.',
        'vigencia' : '5 al 16 de octubre de 2026.',
        'descripcionProcedimiento' : 'Pavimentación del camino Xochimilco - Otlamalacatla, en el municipio de Tianguistengo.; ubicada en la localidad de Xochimilco, Municipio de Tianguistengo, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }48/N167/N167.rar`,
        'start' : '2026-10-05',
        'end' : '2026-10-16',
        'procedimiento' : 'Licitación Pública',
    }
]